import { cx } from '@utils/cx';
import { Input } from 'antd';
import { PasswordProps } from 'antd/lib/input';

const Password = (props: PasswordProps) => <Input.Password {...props} className={cx('customInput', props.className)} />;

export default Password;
